var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section_gap_x" }, [
    !_vm.isReadyToAcceptPayment && _vm.cart.summary.order_id
      ? _c(
          "section",
          { staticClass: "container_section" },
          [
            _c("div", [_vm.isFetchingOrder ? _c("LoaderRound") : _vm._e()], 1),
            _vm._v(" "),
            _vm.isDetailsShow
              ? _c("div", [
                  _c("p", { staticClass: "paragraph paragraph--black" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("CATELOGUE_ORDER_PAYMENT.QUEUE_TABLE.ORDER_ID")
                        ) +
                        "\n              " +
                        _vm._s(_vm.orderSummary.order_id) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph paragraph--black" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "CATELOGUE_ORDER_PAYMENT.QUEUE_TABLE.ORDER_DATE"
                          )
                        ) +
                        "\n              " +
                        _vm._s(_vm.orderSummary.createdAt) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "paragraph paragraph--black" }, [
                    _vm._v(
                      _vm._s(_vm.count) +
                        " " +
                        _vm._s(
                          _vm.$t("CATELOGUE_ORDER_PAYMENT.HEADER.DESCRIPTION")
                        )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isDetailsShow
              ? _c("OrderItemsBreakdownTable", {
                  attrs: {
                    order_items: _vm.orderSummary.order_items,
                    cols: _vm.cols,
                    summary: _vm.orderSummary
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("p", { staticClass: "sp_title_md description" }, [
                _vm._v(_vm._s(_vm.distanceBasedMsg))
              ])
            ]),
            _vm._v(" "),
            !_vm.isHideAllBtn || !_vm.isFetchingOrder
              ? _c(
                  "div",
                  [
                    _vm.isCancelOrReorderBtn === "confirm"
                      ? _c(
                          "shop-button",
                          {
                            attrs: {
                              className: "confirm_btn",
                              isLoading: _vm.isConfirmOrderLoading
                            },
                            on: { click: _vm.confirmFinalOrderHandler }
                          },
                          [_vm._v("Confirm")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isHideCancelBtn
                      ? _c(
                          "shop-button",
                          {
                            attrs: {
                              className: "mx-auto",
                              disabled: _vm.isReadyToAcceptPayment,
                              isLoading: _vm.isOrderCancelLoading
                            },
                            on: { click: _vm.cancelOrderHandler }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CATELOGUE_ORDER_PAYMENT.CANCEL_BTN")
                              )
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.cart.summary.allowToReOrder
      ? _c(
          "section",
          { staticClass: "container section_gap_y" },
          [
            _c(
              "div",
              { staticClass: "title_header text_center section_gap_y" },
              [
                _c("p", { staticClass: "sp_title_md description" }, [
                  _vm._v(_vm._s(_vm.$t("PRODUCT.ORDER_MSG.CANCEL_MSG")))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "shop-button",
              {
                attrs: {
                  isLoading: _vm.isConfirmOrderLoading,
                  className: "section_gap_y"
                },
                on: { click: _vm.reOrderHandler }
              },
              [_vm._v(_vm._s(_vm.$t("PRODUCT.ORDER_MSG.RE_ORDER_BTN")))]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("section", [_c("order-list")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }